import axiosIns from '@/libs/axios'

function postList(url, params) {
  return axiosIns
    .post(url, JSON.stringify(params))
    .then(response => ({
      data: response.data.data || [],
      count: response.data.count || 0,
    }))
    .catch(error => {
      console.error(error)
      return { data: [], count: 0 }
    })
}

export default {
  namespaced: true,
  state: {
    loading: false,
    counts: {
      customers: 0,
      licenses: 0,
      activeLicenses: 0,
      projects: 0,
      users: 0,
      eventLogs: 0,
    },
    recentLicenses: [],
    expiringLicenses: [],
    recentEvents: [],
  },
  getters: {
    loading(state) {
      return state.loading
    },
    counts(state) {
      return state.counts
    },
    recentLicenses(state) {
      return state.recentLicenses
    },
    expiringLicenses(state) {
      return state.expiringLicenses
    },
    recentEvents(state) {
      return state.recentEvents
    },
  },
  mutations: {
    SET_LOADING(state, value) {
      state.loading = value
    },
    SET_COUNTS(state, counts) {
      state.counts = { ...state.counts, ...counts }
    },
    SET_RECENT_LICENSES(state, data) {
      state.recentLicenses = data
    },
    SET_EXPIRING_LICENSES(state, data) {
      state.expiringLicenses = data
    },
    SET_RECENT_EVENTS(state, data) {
      state.recentEvents = data
    },
  },
  actions: {
    async loadOverview({ commit }) {
      commit('SET_LOADING', true)

      const today = new Date()
      today.setHours(0, 0, 0, 0)
      const inThirtyDays = new Date(today)
      inThirtyDays.setDate(inThirtyDays.getDate() + 30)

      const [
        customers,
        licenses,
        activeLicenses,
        projects,
        users,
        eventLogs,
        recentLicenses,
        licensePool,
        recentEvents,
      ] = await Promise.all([
        postList('/Admin/data/customers', {
          select: ['customers.id AS id'],
          limit: 1,
          start: 0,
        }),
        postList('/Admin/data/licenses', {
          select: ['licenses.id AS id'],
          limit: 1,
          start: 0,
        }),
        postList('/Admin/data/licenses', {
          select: ['licenses.id AS id'],
          where: { 'licenses.status': '1' },
          limit: 1,
          start: 0,
        }),
        postList('/Admin/data/projects', {
          select: ['projects.id AS id'],
          limit: 1,
          start: 0,
        }),
        postList('/Admin/core/users', {
          select: ['users.id AS id'],
          limit: 1,
          start: 0,
        }),
        postList('/Admin/data/event_logs', {
          select: ['event_logs.id AS id'],
          limit: 1,
          start: 0,
        }),
        postList('/Admin/data/licenses', {
          select: [
            'licenses.id AS id',
            'licenses.sdate AS sdate',
            'licenses.edate AS edate',
            'licenses.status AS status',
            'customers.company AS customer',
            'projects.title AS project',
            'project_packages.title AS project_package',
          ],
          order_by: ['licenses.id', 'DESC'],
          limit: 8,
          start: 0,
        }),
        postList('/Admin/data/licenses', {
          select: [
            'licenses.id AS id',
            'licenses.sdate AS sdate',
            'licenses.edate AS edate',
            'licenses.status AS status',
            'customers.company AS customer',
            'projects.title AS project',
            'project_packages.title AS project_package',
          ],
          where: { 'licenses.status': '1' },
          order_by: ['licenses.edate', 'ASC'],
          limit: 50,
          start: 0,
        }),
        postList('/Admin/data/event_logs', {
          select: [
            'event_logs.id AS id',
            'event_logs.component AS component',
            'event_logs.action AS action',
            'event_logs.ip_address AS ip_address',
            'event_logs.created AS created',
            'users.name AS username',
          ],
          order_by: ['event_logs.id', 'DESC'],
          limit: 8,
          start: 0,
        }),
      ])

      const expiring = (licensePool.data || []).filter(item => {
        if (!item.edate) return false
        const end = new Date(item.edate)
        return end >= today && end <= inThirtyDays
      }).slice(0, 8)

      commit('SET_COUNTS', {
        customers: customers.count,
        licenses: licenses.count,
        activeLicenses: activeLicenses.count,
        projects: projects.count,
        users: users.count,
        eventLogs: eventLogs.count,
      })
      commit('SET_RECENT_LICENSES', recentLicenses.data)
      commit('SET_EXPIRING_LICENSES', expiring)
      commit('SET_RECENT_EVENTS', recentEvents.data)
      commit('SET_LOADING', false)
    },
  },
}
